import { render, staticRenderFns } from "./yian.vue?vue&type=template&id=87143784&scoped=true&"
import script from "./yian.vue?vue&type=script&lang=ts&"
export * from "./yian.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87143784",
  null
  
)

export default component.exports